import React, { useState, useEffect } from 'react';
import BaseModal from '../BaseModal';
import Icon from '@mdi/react';
import { mdiEmailOutline } from '@mdi/js';
import { organizationApi } from '../../api/organization';
import './EmailTemplatePreviewModal.css';

const EmailTemplatePreviewModal = ({ isOpen, emailType, emailLabel, onClose }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [subject, setSubject] = useState('');
    const [iframeDoc, setIframeDoc] = useState('');

    useEffect(() => {
        if (!isOpen || !emailType) return;
        setIsLoading(true);
        setSubject('');
        setIframeDoc('');
        organizationApi.previewEmailTemplate(emailType, {})
            .then(res => {
                if (res.ok && res.data) {
                    setSubject(res.data.subject || '');
                    setIframeDoc(res.data.html || '');
                }
            })
            .catch(() => {})
            .finally(() => setIsLoading(false));
    }, [isOpen, emailType]);

    return (
        <BaseModal
            isOpen={isOpen}
            onClose={onClose}
            title={emailLabel ? `Preview: ${emailLabel}` : 'Email Template Preview'}
            icon={mdiEmailOutline}
            maxWidth={720}
            footer={
                <button className="base-modal-cancel-btn" onClick={onClose}>
                    Close
                </button>
            }
        >
            {isLoading ? (
                <p className="email-template-preview-modal__loading">Loading preview…</p>
            ) : (
                <div className="email-template-preview-modal__content">
                    <div className="email-template-preview-modal__field">
                        <span className="email-template-preview-modal__label">Subject</span>
                        <p className="email-template-preview-modal__value">{subject || '(no subject)'}</p>
                    </div>
                    <div className="email-template-preview-modal__field">
                        <span className="email-template-preview-modal__label">Body Preview</span>
                        <iframe
                            sandbox="allow-same-origin"
                            srcDoc={iframeDoc}
                            className="email-template-preview-modal__iframe"
                            title="Email template preview"
                        />
                    </div>
                    <p className="email-template-preview-modal__hint">
                        This is a preview using sample data. Variable placeholders appear as-is when no real data is available.
                    </p>
                    {emailType === 'classPayment' && (
                        <p className="email-template-preview-modal__hint">
                            <strong>Bank-transfer block:</strong> The BSB / account / reference section in the preview only appears in real emails when you have the bank-transfer offering turned on (Settings → Payment Settings → Bank Transfer) AND you have saved your bank details. When the offering is off, students see only the "Review &amp; Pay" card-payment button.
                        </p>
                    )}
                </div>
            )}
        </BaseModal>
    );
};

export default EmailTemplatePreviewModal;
